export const LEARNING_OPERATORS = [
  {
    id: 1,
    name: "and",
    i18n: true,
    default: true,
  },
  {
    id: 2,
    name: "or",
    i18n: true,
  },
];

export const EQUALITY_OPERATORS = [
  {
    id: 1,
    name: "equal",
    i18n: true,
    default: true,
  },
  {
    id: 3,
    name: "not_equal",
    i18n: true,
  },
  {
    id: 2,
    name: "like",
    i18n: true,
  },
];

export const LEARNING_PROCESSING_STATUS = [
  {
    id: 1,
    name: "pending",
    i18n: true,
    value: 1,
  },
  {
    id: 2,
    name: "in_progress",
    i18n: true,
    value: 2,
  },
  {
    id: 3,
    name: "completed",
    i18n: true,
    value: 3,
  },
];

export const FIELD_TYPES = [
  {
    id: 1,
    value: 1,
    name: "text",
    i18n: true,
  },
  {
    id: 2,
    value: 2,
    name: "number",
    i18n: true,
  },
  {
    id: 3,
    value: 3,
    name: "dropdown",
    i18n: true,
  },
  {
    id: 4,
    value: 4,
    name: "boolean",
    i18n: true,
  },
  {
    id: 5,
    value: 5,
    name: "date",
    i18n: true,
  },
  {
    id: 6,
    value: 6,
    name: "textlong",
    i18n: true,
  },
];

// Every image picker (certificate designs, thumbnails, email header/footer,
// logo, banner) offers only what the API's Skia-based decoder can read
// (ImageFiles.Check): PNG, JPEG, GIF, WebP and BMP. SVG is never
// offered; the server refuses it with 400 INVALID_IMAGE.
export const IMAGE_UPLOAD_FILE_TYPES = ".png,.jpg,.jpeg,.webp,.gif,.bmp";

export const LEARNING_OBJECT_REPORTS = "learning_objects_reports";
export const LEARNING_MILESTONE_REPORTS = "learning_milestones_reports";
export const LEARNING_PROGRAM_REPORTS = "learning_programs_reports";

export const REPORTS = [
  {
    id: LEARNING_PROGRAM_REPORTS,
    name: LEARNING_PROGRAM_REPORTS,
    i18n: true,
  },
  {
    id: LEARNING_MILESTONE_REPORTS,
    name: LEARNING_MILESTONE_REPORTS,
    i18n: true,
  },
  {
    id: LEARNING_OBJECT_REPORTS,
    name: LEARNING_OBJECT_REPORTS,
    i18n: true,
  },
];

export const LEARNING_STATUS_NOT_STARTED = "NotStarted";
export const LEARNING_STATUS_IN_PROGRESS = "InProgress";
export const LEARNING_STATUS_STARTED = "Started";
export const LEARNING_STATUS_INCOMPLETE = "InComplete";
export const LEARNING_STATUS_COMPLETED = "Completed";
export const LEARNING_STATUS_OVERDUE = "OverDue";

export const LEARNING_STATUSES = [
  {
    id: LEARNING_STATUS_NOT_STARTED,
    value: LEARNING_STATUS_NOT_STARTED,
    i18n: true,
    label: LEARNING_STATUS_NOT_STARTED,
    active: true,
  },
  {
    id: LEARNING_STATUS_IN_PROGRESS,
    value: LEARNING_STATUS_STARTED,
    i18n: true,
    label: LEARNING_STATUS_IN_PROGRESS,
    active: true,
  },
  {
    id: LEARNING_STATUS_COMPLETED,
    value: LEARNING_STATUS_COMPLETED,
    i18n: true,
    label: LEARNING_STATUS_COMPLETED,
    active: true,
  },
  {
    id: LEARNING_STATUS_OVERDUE,
    value: LEARNING_STATUS_OVERDUE,
    i18n: true,
    label: LEARNING_STATUS_OVERDUE,
    active: true,
  },
];

export const TRAINING_TYPE_REQUIRED = "required";
export const TRAINING_TYPE_OPTIONAL = "optional";
export const TRAINING_TYPE_ALL = "all";

// Report "type" filter; the API defaults to Required when it is absent.
export const REPORT_TRAINING_TYPES = [
  {
    id: "training_required",
    value: TRAINING_TYPE_REQUIRED,
    i18n: true,
  },
  {
    id: "optional",
    value: TRAINING_TYPE_OPTIONAL,
    i18n: true,
  },
  {
    id: "training_type_all",
    value: TRAINING_TYPE_ALL,
    i18n: true,
  },
];

export const LANGUAGES = [
  { code: "af", name: "Afrikaans (Afrikaans)" },
  { code: "sq", name: "Albanian (Shqip)" },
  { code: "am", name: "Amharic (አማርኛ)" },
  { code: "ar", name: "Arabic (العربية)" },
  { code: "hy", name: "Armenian (Հայերեն)" },
  { code: "az", name: "Azerbaijani (Azərbaycan dili)" },
  { code: "bn", name: "Bengali (বাংলা)" },
  { code: "bs", name: "Bosnian (Bosanski)" },
  { code: "bg", name: "Bulgarian (Български)" },
  { code: "ca", name: "Catalan (Català)" },
  { code: "zh", name: "Chinese (中文)" },
  { code: "zh-CN", name: "Chinese Simplified (简体中文)" },
  { code: "zh-TW", name: "Chinese Traditional (繁體中文)" },
  { code: "zh-HK", name: "Chinese Hong Kong (香港繁體中文)" },
  { code: "hr", name: "Croatian (Hrvatski)" },
  { code: "cs", name: "Czech (Čeština)" },
  { code: "da", name: "Danish (Dansk)" },
  { code: "nl", name: "Dutch (Nederlands)" },
  { code: "en", name: "English US (English)" },
  { code: "en-GB", name: "English UK (English)" },
  { code: "et", name: "Estonian (Eesti)" },
  { code: "fi", name: "Finnish (Suomi)" },
  { code: "fr", name: "French (Français)" },
  { code: "fr-CA", name: "French Canadian (Français Canadien)" },
  { code: "ka", name: "Georgian (ქართული)" },
  { code: "de", name: "German (Deutsch)" },
  { code: "el", name: "Greek (Ελληνικά)" },
  { code: "he", name: "Hebrew (עברית)" },
  { code: "hi", name: "Hindi (हिन्दी)" },
  { code: "hu", name: "Hungarian (Magyar)" },
  { code: "is", name: "Icelandic (Íslenska)" },
  { code: "id", name: "Indonesian (Bahasa Indonesia)" },
  { code: "it", name: "Italian (Italiano)" },
  { code: "ja", name: "Japanese (日本語)" },
  { code: "jv", name: "Javanese (ꦧꦱꦗꦮ)" },
  { code: "ko", name: "Korean (한국어)" },
  { code: "ms", name: "Malay (Bahasa Melayu)" },
  { code: "mn", name: "Mongolian (Монгол)" },
  { code: "no", name: "Norwegian (Norsk)" },
  { code: "fa", name: "Persian (فارسی)" },
  { code: "pl", name: "Polish (Polski)" },
  { code: "pt", name: "Portuguese (Português)" },
  { code: "pt-BR", name: "Portuguese Brazil (Português do Brasil)" },
  { code: "pt-PT", name: "Portuguese Portugal (Português Europeu)" },
  { code: "pa", name: "Punjabi (ਪੰਜਾਬੀ)" },
  { code: "ro", name: "Romanian (Română)" },
  { code: "ru", name: "Russian (Русский)" },
  { code: "sr", name: "Serbian (Српски)" },
  { code: "si", name: "Sinhala (සිංහල)" },
  { code: "sk", name: "Slovak (Slovenčina)" },
  { code: "sl", name: "Slovenian (Slovenščina)" },
  { code: "es", name: "Spanish (Español)" },
  { code: "es-ES", name: "Spanish Spain (Español de España)" },
  { code: "es-LA", name: "Spanish Latin American (Español latinoamericano)" },
  { code: "sw", name: "Swahili (Kiswahili)" },
  { code: "sv", name: "Swedish (Svenska)" },
  { code: "ta", name: "Tamil (தமிழ்)" },
  { code: "te", name: "Telugu (తెలుగు)" },
  { code: "th", name: "Thai (ไทย)" },
  { code: "tr", name: "Turkish (Türkçe)" },
  { code: "uk", name: "Ukrainian (Українська)" },
  { code: "ur", name: "Urdu (اردو)" },
  { code: "vi", name: "Vietnamese (Tiếng Việt)" },
  { code: "xh", name: "Xhosa (isiXhosa)" },
  { code: "zu", name: "Zulu (isiZulu)" },
];
